import styled from "styled-components";
import {Link} from 'react-router-dom';

export const LinkStyle = styled(Link)`
	border-bottom: 2px solid ${props => props.theme.primaryColor};
`;

export const AnchorStyle = styled.a`
	border-bottom: 2px solid ${props => props.theme.primaryColor};
`;